<template>
  <div id="app">
    <NavBar v-if="this.$store.getters['Global/isLoggedIn']" />
    <div class="container-fluid w-100 container-fluid w-100">
      <router-view />
      <VLibras />
    </div>
  </div>
</template>

<script>
import NavBar from './components/Default/NavBar'
import router from './router/index'
import { VLibras } from '@vue-a11y/vlibras'

export default {
  name: 'App',
  components: {
    NavBar,
    VLibras
  },
  created () {
    window.addEventListener('storage', this.checkEvent)
  },
  methods: {
    checkEvent (event) {
      if (event.key === 'token') {
        window.location.reload()
        router.push('/home')
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #000;
  color: white;
  text-align: center;
}

#nav {
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

div.active {
  background-color: #fff;
}
</style>
